<div class="h-full widget-belender">
  <div *ngIf="data && data.styles && data.styles.colors" class="h-full w-full flex-auto p-0 md:p-3 {{data?.styles?.typography}}" [style.background]="data?.styles?.colors?.background">


    <div *ngIf="data.config.infiniteLoopInCompleted && requestStatus === 'loading'" class="flex justify-center h-full min-h-[300px] items-center">
      <mat-progress-spinner  color="accent" diameter="40" class="spinner" [value]="0" mode="indeterminate"></mat-progress-spinner>
    </div>

    <ng-container *ngIf="!error && !disableURL" >

      <belender-intro-step
        *ngIf="requestStatus === 'intro'"
        [data]="data"
        [flowName]="flowName"
        class="h-full "
        (gotoFlow)="goFlow()"
        (gotoManual)="gotoManual()"
      ></belender-intro-step>

      <belender-manual-step
        *ngIf="requestStatus === 'manual'"
        [data]="data"
        [flowName]="flowName"
        [packId]="packId"
        [userId]="userId"
        [labels]="labels"
        class="h-full "
      ></belender-manual-step>

      <!-- Form -->
      <belender-form-step
        #formStep
        [requestIDFromURL]="requestIDFromURL"
        *ngIf="requestStatus === 'form' && !settingRequestFromBack"
        [lang]="currentLang"
        [requestID]="requestID"
        [flowName]="flowName"
        [data]="data"
        [labels]="labels"
        [texts]="data[flowName]?.texts"
        [pinMode]="pinMode"
        [editable_dates]="editable_dates"
        [skipCreationOfRequest]="skipCreationOfRequest"
        (goToTerms)="gotoTermsAndConditions()"
      ></belender-form-step>

      <!-- Error steps --------------------- -->
      <belender-error-form-step
        *ngIf="requestStatus === 'error-data'"
        [data]="data"
        [labels]="labels"
        [texts]="data[flowName]?.texts"
        [flowName]="flowName"
        [requestID]="requestID"
      ></belender-error-form-step>

      <belender-error-birthday-step
        *ngIf="requestStatus == 'error-birth-date'"
        [data]="data"
        [labels]="labels"
        [texts]="data[flowName]?.texts"
      ></belender-error-birthday-step>

      <belender-error-expiration-step
        *ngIf="requestStatus == 'error-expiration-date'"
        [data]="data"
        [labels]="labels"
        [texts]="data[flowName]?.texts"
      ></belender-error-expiration-step>

      <belender-error-support-number-step
        *ngIf="requestStatus == 'error-support-number'"
        [data]="data"
        [labels]="labels"
        [texts]="data[flowName]?.texts"
      ></belender-error-support-number-step>

      <!-- Abandoned -->
      <belender-abandoned-step
        *ngIf="requestStatus == 'abandoned'"
        [requestID]="requestID"
        [data]="data"
        [labels]="labels"
        [texts]="data[flowName]?.texts"
        [flowType]="flowName"
      ></belender-abandoned-step>

      <!-- OTP -->
      <belender-shared-otp-step
        #otpStep
        *ngIf="requestStatus == 'otp'"
        [otpType]="'otpSS'"
        [requestID]="requestID"
        [testMode]="testMode"
        [labels]="labels"
        [logoCustom]="data[flowName]?.texts?.otpSS?.customImage"
        [flowType]="flowName"
        [data]="data"
        [texts]="data[flowName]?.texts"
        [minLength]="6"
      ></belender-shared-otp-step>

      <!-- Success -->
      <belender-success-step
        *ngIf="requestStatus == 'success'"
        [data]="data"
        [labels]="labels"
        [packId]="packId"
        [flowName]="flowName"
        [userId]="userId"
        [requestID]="requestID"
        [texts]="data[flowName]?.texts"
      ></belender-success-step>

      <!-- Duplicated -->
      <belender-duplicated-request-step
        *ngIf="requestStatus == 'duplicated'"
        [data]="data"
        [labels]="labels"
        (newRequest)="newRequest($event)"
        [currentRequest]="currentRequest"
      ></belender-duplicated-request-step>

       <!-- No phone steps --------------------- -->
      <belender-no-phone-step
       *ngIf="requestStatus == 'no-phone'"
       [data]="data"
       [labels]="labels"
       [flowName]="flowName"
       [texts]="data[flowName]?.texts"
      ></belender-no-phone-step>

      <!-- OTP retry -->
      <belender-error-phone-step
        *ngIf="requestStatus == 'bad-phone'"
        [data]="data"
        [labels]="labels"
        [texts]="data[flowName]?.texts"
        [flowName]="flowName"
      ></belender-error-phone-step>

      <!-- Failed -->
      <belender-fail-step
        *ngIf="requestStatus == 'failed'"
        [data]="data"
        [labels]="labels"
        [texts]="data[flowName]?.texts"
        [requestID]="requestID"
        [flowType]="flowName"
        (newRequest)="newRequest($event)"
      ></belender-fail-step>


      <!-- Failed No service -->
      <belender-no-service-step
        *ngIf="requestStatus == 'no-service'"
        [texts]="data[flowName]?.texts"
        [data]="data"
        [labels]="labels"
      ></belender-no-service-step>

      <belender-standby-step
        *ngIf="requestStatus == 'standby'"
        [texts]="data[flowName]?.texts"
        [data]="data"
        [labels]="labels"
      ></belender-standby-step>

      <!-- CancelRequest Button -->
      <belender-cancel-request
        *ngIf="showCancelRequest && data.config.cancelRequest && requestIDFromURL"
        [flowType]="flowName"
        [request_id]="requestID"
        [user_id]="userId"
        [data]="data"
        [labels]="labels"
        [textColor]="data.styles.colors.text"
        [customText]="data.config.cancelRequestText"
        >
      </belender-cancel-request>

      <!-- Custom aditionalDescription -->
      <div
        *ngIf="requestStatus === 'form' && !loading && data[flowName] && data[flowName]?.showAditionalDescription && data[flowName]?.texts && data[flowName]?.texts.form && data[flowName]?.texts.form.aditionalDescription"
        [style.color]="data.styles.colors.text"
        class="subheading-1 p-4 custom-html"
        [innerHTML]="data[flowName]?.texts?.form?.aditionalDescription || ''  | safeHtml">
      </div>
    </ng-container>

    <belender-disabled-url *ngIf="!error && disableURL"></belender-disabled-url>

    <div class="animated w-full fadeInRight" *ngIf="!loading && warning && requestStatus != 'success' && requestStatus != 'abandoned' && requestStatus != 'failed'" >
      <div class="px-6 py-4 w-full bg-orange-500/10 rounded-md flex flex-col text-orange-600" [innerHTML]="warning"></div>
    </div>

    <div  *ngIf="!loading && error && requestStatus != 'loading'">
      <div class="px-6 py-4 flex flex-col ">
        <div class="text-red-500 title m-0">Error!</div>
        <div [style.color]="data.styles.colors.text" class="subheading-1 pt-4" [innerHTML]="error"></div>
      </div>
      <div class="flex items-center justify-end gap-2 p-4">
        <button (click)="error = false" class="text-blue-500 bg-blue-50 px-8" mat-flat-button type="button">Ingresar manualmente</button>
      </div>
    </div>

  </div>

  <div *ngIf="loading && !error" class="loading-wrapper">
    <!-- <mat-progress-spinner mode="indeterminate" color="accent"></mat-progress-spinner> -->
    <mat-progress-spinner color="accent" diameter="40" class="spinner" [value]="spinnerValue" [mode]="spinnerMode"></mat-progress-spinner>
    <p class="mt-6 text-center text-black" style="color: black !important;">{{loading}}</p>
  </div>
</div>

<vex-terms
  *ngIf="showTermsDialog"
  [flow]="flowName"
  [lang]="currentLang"
  [allData]="data"
  [requestStatus]="smsFlowService.REQUEST ? smsFlowService.REQUEST_STATUS : ''"
  [requestID]="requestID"
  (accepted)="handleTermsResponse(true)"
  (cancelled)="handleTermsResponse(false)"
>
</vex-terms>

<ng-container *ngIf="testMode">
  <div class="test-mode px-10 py-2 bg-blue-500/10 text-blue-500 border-blue-500 border rounded-md ">TestMode {{testMode ? 'ON' : 'OFF'}}</div>
</ng-container>

<belender-tester-sms *ngIf="testMode" (sendMessage)="setMessageFromTest($event)"></belender-tester-sms>
